import { handleExperimentsResponse } from '../../common/store/experiments/experiments-actions';
import { getQueryLocale } from '../../common/selectors/locale-selectors';
import { getCategoryPath } from '@wix/communities-blog-client-common';
import { handleCategoryMenuWidgetResponse } from '../aggregated-category-menu/actions';

export const fetchCategoryWidgetInitialData =
  ({ useYoshiExperiments } = {}) =>
  async (dispatch, getState, { aggregatorRequest }) => {
    const langQuery = getQueryLocale(getState());
    const language = langQuery ? `&language=${langQuery}` : '';
    const categoryPath = getCategoryPath(getState());
    const { experiments, categoryMenu } = await aggregatorRequest(
      `/v1/category-menu-widget/render-model?categoryPath=${categoryPath}${language}`,
      {
        throwOnInvalidJson: true,
      },
    );

    await Promise.all([
      useYoshiExperiments ? undefined : dispatch(handleExperimentsResponse(experiments)),
      dispatch(handleCategoryMenuWidgetResponse(categoryMenu)),
    ]);
  };
